module.exports = __webpack_public_path__ + "pc/img/wb.337ec51d.png";